import { createStyles, makeStyles } from "@material-ui/core";

import { baseColors, RelodeTheme } from "..";

export const useTileStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                height: "100%",
                width: "100%",
            },
            content: {
                padding: theme.spacing(2),
            },
            noPaper: {
                padding: 0,
                backgroundColor: "transparent",
                display: "flex",
                flexDirection: "row",
                columnGap: "40px",
            },
            paper: {
                height: "100%",
                boxShadow: "0 2px 4px 0 rgba(0,0,0,0.1)",
            },
            addIcon: {
                marginRight: theme.spacing(1),
            },
            addContainer: {
                marginBottom: theme.spacing(2),
            },
            tilesSectionPaper: {
                [theme.breakpoints.up("md")]: {
                    display: "flex",
                },
            },
            tilesSection: {
                display: "flex",
                placeItems: "flex-start",
                padding: "8px 16px 16px 16px",
            },
            sectionTitleFlex: {
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: theme.spacing(1),
            },
            firstSectionWrapper: {
                padding: "0px 0px 32px 0px",
            },
            sectionWrapper: {
                padding: "32px 0px 32px 0px",
            },
            statusTile: {
                flexGrow: 1,
                marginTop: theme.spacing(1),
                [theme.breakpoints.up("md")]: {
                    marginTop: 0,
                },
            },
            statusContent: {
                color: baseColors.navy,
                margin: 0,
                fontFamily: [
                    // eslint-disable-next-line quotes
                    '"hkgrotesk_bold"',
                    "Helvetica",
                    "sans-serif",
                ].join(","),
            },
            statusTitle: {
                color: baseColors.light_black,
                fontSize: "1rem",
                fontFamily: [
                    // eslint-disable-next-line quotes
                    '"hkgrotesk_regular"',
                    "Helvetica",
                    "sans-serif",
                ].join(","),
            },
            tilePaper: {
                height: "100px",
                minWidth: "100px",
            },
            funnelTitle: {
                marginBottom: theme.spacing(3),
            },            
        }),
    { name: "TilesSection" }
);